<template>
  <div class="app-container" style="padding: 10px">
    <div class="filter-container">
      <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
        <el-form-item label="时间" class="custom-item">
          <el-date-picker
            v-model="bitTime"
            :default-time="['12:00:00']"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
          />
        </el-form-item>
        <el-form-item label="." class="custom-item">
          <el-button
            v-waves
            v-loading.fullscreen.lock="listLoading"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >{{ $t('table.search') }}</el-button>
        </el-form-item>
        <el-form-item label="." class="custom-item">
          <el-button
            v-waves
            class="filter-item"
            type="info"
            icon="el-icon-document"
            @click="handlePointToExcel"
          >导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="类型" align="center" width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.pointTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="积分" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.point }}</span>
        </template>
      </el-table-column>
      <el-table-column label="剩余积分" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.balancePoint }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.memo }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.pi"
        :page-sizes="[10,20,30]"
        :page-size="listQuery.ps"
        :total="total"
        background
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { fetchPointHistory } from '@/api/record'
import { getDateOfMonth } from '../../utils'
import waves from '@/directive/waves' // 水波纹指令
import { pointRecordToExcel } from '@/api/download'
import { downloadFile } from '@/utils/file'
export default {
  name: 'HistoryPoint',
  directives: {
    waves
  },
  props: {
    companyId: {
      type: Number,
      required: true
    },
    memberId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      tableKey: 0,
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        pi: 1,
        ps: 20,
        beginTime: '',
        endTime: ''
      },
      payLists: [],
      bitTime: getDateOfMonth(1)
    }
  },
  watch: {
    $route () {
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      this.listQuery['companyId'] = this.companyId
      this.listQuery['memberId'] = this.memberId
      if (this.bitTime) {
        this.listQuery.beginTime = this.bitTime[0]
        this.listQuery.endTime = this.bitTime[1]
      }
      fetchPointHistory(this.listQuery).then(response => {
        const row = response.data
        console.log(row)
        if (row.data) {
          this.list = row.data.items
          this.total = row.data.totalItems
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.pi = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.ps = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.pi = val
      this.getList()
    },
    handlePointToExcel () {
      let loadingIns
      this.$confirm('确定导出加油记录为excel吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        loading: true,
        type: 'info'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        loadingIns = loading
        pointRecordToExcel(this.listQuery).then(response => {
          if (response.data) {
            const type = response.headers['content-type']
            // response.setHeader("Content-Type", "application/vnd.ms-excel"); type必须和后端的type一致
            downloadFile(response, type)
            loadingIns.close()
          }
        }).catch(e => {
          this.$message({
            type: 'warning',
            message: '导出失败！ 原因：' + e
          })
          loadingIns.close()
        })
      }).catch(() => {
        this.$message({
          type: 'warning',
          message: '取消导出！'
        })
        loadingIns.close()
      })
    }
  }
}
</script>

